import * as Cookies from 'js-cookie';

import Bag from './Bag';

import FindInBoutique from '@phoenix/components/FindInBoutique';

export default class SizeSelector {
  public static readonly CSS_SELECTOR_FOR_SIZE_SELECT = '.product-size-selector';
  public static readonly CSS_SELECTOR_FOR_SIZE_RADIO = '.product-size-radio-selector input';
  public static readonly CSS_SELECTOR_FOR_PRICE_FROMS = '.price-form';
  public static readonly CSS_SELECTOR_FOR_STOCK_NOTIFICATION_BTN = '.btn-stock-notification';
  public static readonly SIZE_SELECT_LIGHT_ECOM_ATTRIBUTE = 'data-light-ecom';
  public static readonly CSS_SELECTOR_FOR_LIGHT_ECOM_BTN = '#light-ecom-btn';
  public static readonly CSS_SELECTOR_FOR_ADD_TO_BAG_TOOLTIP = '.add-to-bag-tooltip';

  private bag: Bag;
  private findInBoutique: FindInBoutique;
  private readonly sizeSelectors: NodeListOf<HTMLElement>;
  private readonly sizeRadioSelector: NodeListOf<HTMLElement>;
  private priceFroms: NodeListOf<Element>;
  private readonly stockNotifyBtns: NodeListOf<HTMLElement>;
  private readonly addToBagTooltips: NodeListOf<HTMLElement>;
  private readonly availableReferences: object;

  constructor(bag, findInBoutique, availableReferences) {
    this.bag = bag;
    this.findInBoutique = findInBoutique;

    this.sizeRadioSelector = document.querySelectorAll(SizeSelector.CSS_SELECTOR_FOR_SIZE_RADIO);
    this.sizeSelectors = document.querySelectorAll(SizeSelector.CSS_SELECTOR_FOR_SIZE_SELECT);
    this.priceFroms = document.querySelectorAll(SizeSelector.CSS_SELECTOR_FOR_PRICE_FROMS);
    this.stockNotifyBtns = document.querySelectorAll(SizeSelector.CSS_SELECTOR_FOR_STOCK_NOTIFICATION_BTN);
    this.addToBagTooltips = document.querySelectorAll(SizeSelector.CSS_SELECTOR_FOR_ADD_TO_BAG_TOOLTIP);

    this.availableReferences = availableReferences;

    const sizeSelectorEnabler = (sizeValue) => {
      const currentCountryCode = Cookies.get('currentCountry').toUpperCase();
      const countryPrices = this.availableReferences[currentCountryCode];
      const selectedSize = countryPrices ? countryPrices[sizeValue] : false;

      this.bag.disable();

      if (selectedSize) {
        if (this.priceFroms) {
          this.priceFroms.forEach((priceFrom) => {
            const price = priceFrom.querySelector('.price-inside-from');
            priceFrom.parentNode.replaceChild(price, priceFrom);
          });
          this.priceFroms = null;
        }

        const priceElem = document.querySelectorAll(
          '.product-page-prices span[data-country-code]:not(.hidden) span[data-price="value"]',
        );

        const affirmPriceElem = document.querySelector('.affirm-as-low-as');

        if (affirmPriceElem && affirm && affirm.ui) {
          // Affirm data-amount property must be updated with a value of price * 100, see docs
          const affirmPriceDataAmount = parseInt(selectedSize.price.replace(',', '')) * 100;
          affirmPriceElem.setAttribute('data-amount', affirmPriceDataAmount.toString());

          // If affirm sandbox is not loaded correctly we wrap it in ready function.
          // Doing so ensures that the page does not call the refresh function before Affirm.js initializes or when it's not loaded correctly.
          if (affirm.ui.ready) {
            affirm.ui.ready(() => {
              affirm.ui.refresh();
            });
          } else if (affirm.ui.refresh) {
            affirm.ui.refresh();
          }
        }

        if (priceElem) {
          priceElem.forEach((el) => (el.innerHTML = selectedSize.price));
        }

        if (selectedSize.inStock || selectedSize.prepayment) {
          this.bag.activate();
          this.bag.setReference(selectedSize.reference);
          this.findInBoutique.setReference(selectedSize.reference);

          this.addToBagTooltips.forEach((el) => el.classList.add('hidden'));

          if (this.stockNotifyBtns) {
            this.stockNotifyBtns.forEach((stockNotifyBtn) => stockNotifyBtn.classList.add('hidden'));
          }
        } else if (!selectedSize.inStock && this.stockNotifyBtns) {
          this.bag.hide();
          this.stockNotifyBtns.forEach((stockNotifyBtn) => stockNotifyBtn.classList.remove('hidden'));
          this.stockNotifyBtns.forEach((stockNotifyBtn) =>
            stockNotifyBtn.setAttribute('data-product-reference', selectedSize.reference),
          );
        }

        // Prepayment
        const prepaymentElem = document.getElementById('product-prepayment');
        if (prepaymentElem) {
          if (selectedSize.prepayment) {
            // Update partial price
            const prepaymentTextElem = document.getElementById('product-prepayment-text');
            const prepaymentTranslationKey = `ProductPage.prepayment.${selectedSize.isPartial ? 'partial' : 'full'}`;
            prepaymentTextElem.innerHTML = window.Phoenix.i18n.t(prepaymentTranslationKey, {
              price: selectedSize.prepayment.price,
            });
            // Display prepayment information
            prepaymentElem.classList.remove('hidden');
          } else {
            // Hide prepayment information
            prepaymentElem.classList.add('hidden');
          }
        }
      }
    };

    if (this.sizeRadioSelector) {
      this.sizeRadioSelector.forEach((sizeSelector) => {
        sizeSelector.addEventListener('change', (e) => {
          const target = e.target as HTMLInputElement;
          sizeSelectorEnabler(target.value);
        });
      });
    }

    if (this.sizeSelectors) {
      this.sizeSelectors.forEach((sizeSelector) => {
        if (sizeSelector.getAttribute(SizeSelector.SIZE_SELECT_LIGHT_ECOM_ATTRIBUTE)) {
          return sizeSelector.addEventListener('change', (e) =>
            this.setLightEcomChangeEvent(e.target as HTMLInputElement),
          );
        }

        sizeSelector.addEventListener('change', (e) => {
          const target = e.target as HTMLInputElement;

          sizeSelectorEnabler(target.value);

          document.getElementById('size-selector-wrapper')?.classList.toggle('is-visible', true);
          document.getElementById('show-size-selector-wrapper')?.classList.toggle('hidden', true);

          this.sizeSelectors.forEach((sizeSelector) => {
            if (sizeSelector === e.target) {
              return;
            }
            sizeSelector.value = target.value;
          });
        });
      });
    }
  }

  setLightEcomChangeEvent(target: HTMLInputElement) {
    const lightEcomBtn = document.querySelector(SizeSelector.CSS_SELECTOR_FOR_LIGHT_ECOM_BTN);
    const currentHrefUrl = new URL(lightEcomBtn.getAttribute('href'));
    currentHrefUrl.searchParams.set('reference', target.value);
    lightEcomBtn.setAttribute('href', currentHrefUrl.toString());
  }
}
